import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.object.assign.js';
import { __rest } from 'tslib';
import { jsx, jsxs } from 'react/jsx-runtime';
import React, { useRef } from 'react';
import classNames from 'classnames';
import { CloseIcon } from '@cognite/cogs-icons';
import { useIsOverflowing, getThemeClassNames } from '@cognite/cogs-utils';
import '../../tokens/color-tokens/index.js';
import '../../tokens/elevation-tokens/index.js';
import { Body } from '../../tokens/typography/typography.js';
import { Tooltip } from '../tooltip/tooltip.js';
import 'core-js/modules/es.array.map.js';
import { IconButton } from '../_technical/icon-button/icon-button.js';
import { Button } from '../button/button.js';
import { useConfigContextLoose } from '../config-provider/config-provider.js';

/**
 * Describe what your component does, and why it could be useful for users.
 */
var FilterChip = /*#__PURE__*/React.forwardRef(function (_a, outerRef) {
  var className = _a.className,
    testId = _a['data-testid'],
    inverted = _a.inverted,
    _a$tooltip = _a.tooltip,
    tooltip = _a$tooltip === undefined ? true : _a$tooltip,
    tooltipProps = _a.tooltipProps,
    label = _a.label,
    onRemove = _a.onRemove,
    _a$size = _a.size,
    size = _a$size === undefined ? 'small' : _a$size,
    themeProps = _a.themeProps,
    otherProps = __rest(_a, ["className", 'data-testid', "inverted", "tooltip", "tooltipProps", "label", "onRemove", "size", "themeProps"]);
  var ref = useRef(null);
  var isOverflowing = useIsOverflowing(ref, label);
  var showTooltip = tooltip === true && isOverflowing || typeof tooltip === 'string';
  var _useConfigContextLoos = useConfigContextLoose(),
    getOverlayContainer = _useConfigContextLoos.getOverlayContainer;
  return jsx(Tooltip, Object.assign({
    content: typeof tooltip === 'string' ? tooltip : label,
    disabled: !showTooltip,
    appendTo: getOverlayContainer === null || getOverlayContainer === undefined ? undefined : getOverlayContainer()
  }, tooltipProps, {
    children: jsxs("div", Object.assign({
      ref: outerRef,
      "data-testid": testId || label,
      className: classNames.apply(undefined, ['cogs-v10', 'cogs-filterchip', "cogs-filterchip--" + size].concat(getThemeClassNames(inverted, themeProps), [{
        'cogs-filterchip--is-interactive': !!onRemove
      }, className]))
    }, otherProps, {
      children: [jsx(Body, {
        size: size,
        ref: ref,
        strong: true,
        className: classNames('cogs-v10', 'cogs-filterchip--text'),
        children: label
      }), onRemove && (size === 'x-small' ? jsx(IconButton, {
        icon: CloseIcon,
        "aria-label": "Remove " + label,
        toggled: false,
        onClick: function onClick(e) {
          return onRemove(e, label);
        }
      }) : jsx(Button, {
        className: classNames('cogs-v10', 'cogs-filterchip__button'),
        size: size,
        icon: jsx(CloseIcon, {}),
        "aria-label": "Remove " + label,
        type: "ghost",
        toggled: false,
        onClick: function onClick(e) {
          return onRemove(e, label);
        }
      }))]
    }))
  }));
});

export { FilterChip };
